<script setup>
import { WdsItemPicker } from '@wds/components';
import { buildUrlSearchParamsFromRouteQuery } from '@/lib/urls';
import { useLanguageStore } from '@/stores/language';

const {
  locale,
  locales,
  setLocaleCookie,
  defaultLocaleObj,
} = useI18n();

const { isBelowMediumScreen } = useMq();

const languageStore = useLanguageStore();
const routeStore = useRouteStore();
const route = useRoute();

const currentQueryString = computed(() => {
  const queryString = buildUrlSearchParamsFromRouteQuery(route?.query).toString();
  return queryString ? `?${queryString}` : '';
});

const shouldPreserveQueryParams = computed(() => routeStore.isSearchResultsPage);

setLocaleCookie(locale?.value);

const getLanguagesList = computed(() => {
  return locales?.value?.map((item) => {
    const hrefLangUrl = routeStore.getRouteFromLang(item?.code);
    const hrefUrl = hrefLangUrl ? `${hrefLangUrl}` : `/${item.url}/`;
    const separator = hrefUrl.includes('?') ? '&' : '?';
    const hrefWithQuery = currentQueryString.value
      ? `${hrefUrl}${separator}${currentQueryString.value.slice(1)}`
      : hrefUrl;

    return {
      label: item.name,
      value: item.code,
      href: shouldPreserveQueryParams.value ? hrefWithQuery : hrefUrl,
    };
  });
});

async function handleLanguageSelected(language) {
  const selectedLang = language || defaultLocaleObj.code;
  const langObj = locales?.value?.find((lang) => lang.code === selectedLang);

  languageStore.setLanguage(langObj);

  setLocaleCookie(selectedLang);
}
</script>

<template>
  <div class="language-picker">
    <WdsItemPicker
      :is-open="languageStore?.isLanguagePickerOpen"
      :heading="$t('t_LANGUAGE')"
      :items="getLanguagesList"
      :selected="languageStore?.getCurrentLanguage?.code"
      :is-modal="!isBelowMediumScreen"
      :search-bar="false"
      @close-item-picker="languageStore.toggleLanguagePicker(false)"
      @item-selected="handleLanguageSelected"
    />
  </div>
</template>
